import useStyles from "./styles";
import { Button, ButtonGroup, Grid, Typography } from "@material-ui/core";
import React from "react";
import { Alert } from "@material-ui/lab";
import { DropzoneArea } from "material-ui-dropzone";
import { StepProps } from "./types";
import { StepButtons } from "./components/StepButtons";
import * as tenantApi from "../../../../api/tenantApi";
import { TenantStatus } from "../../../../models/Tenant";
import { useI18n } from "../../../../hooks/useI18n";

export const Product = ({ onNext, onBack }: StepProps) => {
  const { t } = useI18n();
  const classes = useStyles();

  const uploadProducts = async () => {
    await tenantApi.updateTenantStatus(TenantStatus.OnBoardStep3Complete);
    onNext();
  };

  return (
    <>
      <Typography variant={"h5"}>
        {t("common.messages.uploadProducts")}
      </Typography>
      <Grid container>
        <Grid item xs={12}>
          <div className={classes.downloadButtons}>
            <ButtonGroup
              variant="contained"
              color="primary"
              aria-label={t("common.tooltip.containedPrimaryButtonGroup")}
            >
              <Button
                onClick={() => {
                  window.open("/v1/sync/products/price-template");
                }}
              >
                Download product template file
              </Button>
            </ButtonGroup>
          </div>
        </Grid>
        <Grid item xs={12}>
          <Alert severity="info">
            Start by downloading the product template file above (if you haven't
            got it).
            <p>
              1. Fill in the product information for each product you want to
              add.
            </p>
            <p>2. Upload your file</p>
            <p>3. Click "Finish"</p>
            <p>
              If you're using digital price tags they will be updated within
              minutes after the process has finished.
            </p>
          </Alert>
        </Grid>
        <Grid item xs={12}>
          <div className={classes.fileUploadArea}>
            <DropzoneArea
              acceptedFiles={[
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                ".xlsx"
              ]}
              dropzoneText={"Drag and drop your product file here"}
              showPreviewsInDropzone={true}
              useChipsForPreview
              filesLimit={1}
              onChange={data => {}}
            />
          </div>
        </Grid>
        {/*      {state.file ? (
        <>
          <div className={classes.uploadButtons}>
            <Button variant="contained" color="primary" onClick={handleUpload}>
              Update prices
            </Button>
          </div>
        </>
      ) : null}*/}
      </Grid>
      <StepButtons
        onClickNext={uploadProducts}
        onClickBack={onBack}
        lastStep={true}
      />
    </>
  );
};
